import LoyaltyPageSeparated from './LoyaltyPageSeparated';

export default LoyaltyPageSeparated;
